import { useState } from 'react';
import { faqs } from '@/mocks/chigua';
import { SectionHead } from './HotDeep';

export function Faq() {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section id="faq" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <SectionHead
            eyebrow="FAQ"
            title="关于吃瓜今日"
            desc="做这件事的边界、依据与更新节奏，一次性说清楚，也欢迎你随时来信指教。"
          />
          <div className="mt-6 hidden rounded-xl border border-background-200 bg-background-50 p-6 lg:block">
            <p className="font-heading text-lg font-bold text-foreground-950">内容底线</p>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              我们只讨论公开的影像、节目与行业现象，不针对真实个人做揣测或指责；涉及个人的一切判断，一律以官方回应为准。
            </p>
          </div>
        </div>

        <div className="divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q}>
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                  aria-expanded={open}
                >
                  <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{f.q}</h3>
                  <span
                    className={`grid h-8 w-8 shrink-0 place-items-center rounded-full border text-primary-600 transition-transform duration-300 ${
                      open ? 'rotate-45 border-primary-300 bg-primary-50' : 'border-background-200'
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr] pb-5' : 'grid-rows-[0fr]'}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pl-5 text-sm leading-relaxed text-foreground-600 md:pl-24 md:text-base">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}